import { For } from 'solid-js'
import { m } from '~/paraglide/messages'
import { Collapsible } from './collapsible'

export function Faq() {
  const items = [
    { q: m.invite_page_faq_q1(), a: m.invite_page_faq_a1() },
    { q: m.invite_page_faq_q2(), a: m.invite_page_faq_a2() },
    { q: m.invite_page_faq_q3(), a: m.invite_page_faq_a3() },
  ]
  return (
    <Collapsible title={m.faq_label_text()}>
      <div class="flex flex-col gap-4">
        <For each={items}>
          {(item) => (
            <div class="flex flex-col gap-0.5">
              <p class="text-base font-bold text-moss">{item.q}</p>
              <p class="text-sm text-black/55">{item.a}</p>
            </div>
          )}
        </For>
      </div>
    </Collapsible>
  )
}
